import * as yup from 'yup'
import moment from 'moment'

export const schemaTab1 = yup
  .object()
  .shape({
    id: yup.string().nullable(),
    descricao: yup.string().required(),
    cliente: yup.boolean().required(),
    basePropria: yup.boolean().required(),
    carteira: yup.boolean().required(),
    empresasGrupo: yup.array().of(yup.string().required()).min(1),
    tipoCampanhaCrmId: yup.string().nullable().ensure(),
    tipoOperacaoId: yup.string().nullable().ensure(),
    dataInicioCampanha: yup
      .date()
      .min(moment().format('YYYY-MM-DD'))
      .max(yup.ref('dataFimCampanha'))
      .required(),
    dataFimCampanha: yup.date().min(yup.ref('dataInicioCampanha')).required(),
    ufCampanha: yup.array().of(yup.string().required()),
    quantidadeClientes: yup.number().moreThan(0).required(),
    cidadeCampanha: yup.array().of(yup.string().required())
  })

export const schemaTab2 = yup.object().shape(
  {
    redudancia: yup.boolean().required(),
    ignorarClientesCarteira: yup.boolean().required(),
    indisponibilidade: yup.boolean().required(),
    naoPerturbe: yup.boolean().required(),
    telefone: yup.string().nullable(),
    idadeInicial: yup
      .number()
      .when('idadeFinal', {
        is: (idadeFinal: number) => !!idadeFinal || idadeFinal === 0,
        then: (schema) => schema.min(0).max(yup.ref('idadeFinal'))
      })
      .transform((v) => (v || v === 0 ? v : null))
      .nullable(),
    idadeFinal: yup
      .number()
      .when('idadeInicial', {
        is: (idadeInicial: number) => !!idadeInicial || idadeInicial === 0,
        then: (schema) => schema.min(yup.ref('idadeInicial')).max(150)
      })
      .transform((v) => (v || v === 0 ? v : null))
      .nullable(),
    formaRecebimentoBeneficio: yup.number().nullable(),
    cartaoRmc: yup.boolean().nullable(),
    cartaoRcc: yup.boolean().nullable(),
    bancosCartaoRc: yup.array().of(yup.string().required()),
    despachoAnoInicial: yup
      .date()
      .when('despachoAnoFinal', {
        is: (despachoAnoFinal: number) => !!despachoAnoFinal,
        then: (schema) => schema.max(yup.ref('despachoAnoFinal'))
      })
      .nullable()
      .transform((curr, orig) => (orig === '' ? null : curr)),
    despachoAnoFinal: yup
      .date()
      .when('despachoAnoInicial', {
        is: (despachoAnoInicial: number) => !!despachoAnoInicial,
        then: (schema) =>
          schema
            .min(yup.ref('despachoAnoInicial'))
            .max(moment().add(-1, 'months').endOf('month').format('YYYY-MM-DD'))
      })
      .nullable()
      .transform((curr, orig) => (orig === '' ? null : curr)),
    especies: yup.array().of(yup.number().required()),
    quantidadeEmprestimo: yup.boolean().required(),
    quantidadeInicialEmprestimo: yup
      .number()
      .when('quantidadeEmprestimo', {
        is: true,
        then: (schema) =>
          schema.min(1).max(yup.ref('quantidadeFinalEmprestimo')).required()
      })
      .transform((v) => (v || v === 0 ? v : null))
      .nullable(),
    quantidadeFinalEmprestimo: yup
      .number()
      .when('quantidadeEmprestimo', {
        is: true,
        then: (schema) =>
          schema.min(yup.ref('quantidadeInicialEmprestimo')).max(9).required()
      })
      .transform((v) => (v || v === 0 ? v : null))
      .nullable(),
    salario: yup.boolean().oneOf([true]).required(),
    quantidadeInicialSalario: yup
      .number()
      .when('salario', {
        is: true,
        then: (schema) =>
          schema.min(0).max(yup.ref('quantidadeFinalSalario')).required()
      })
      .nullable(),
    quantidadeFinalSalario: yup
      .number()
      .when('salario', {
        is: true,
        then: (schema) =>
          schema
            .min(yup.ref('quantidadeInicialSalario'))
            .max(1000000000.0)
            .required()
      })
      .nullable(),
    margemLivre: yup.boolean().required(),
    representanteLegal: yup.boolean().nullable(),
    quantidadeInicialMargem: yup
      .number()
      .when('margemLivre', {
        is: true,
        then: (schema) =>
          schema.required().min(0).max(yup.ref('quantidadeFinalMargem'))
      })
      .transform((v) => (v || v === 0 ? v : null))
      .nullable(),
    quantidadeFinalMargem: yup
      .number()
      .when('margemLivre', {
        is: true,
        then: (schema) =>
          schema
            .required()
            .min(yup.ref('quantidadeInicialMargem'))
            .max(1000000000.0)
      })
      .transform((v) => (v || v === 0 ? v : null))
      .nullable(),
    margemCartao: yup.boolean().required(),
    quantidadeInicialMargemCartao: yup
      .number()
      .when('margemCartao', {
        is: true,
        then: (schema) =>
          schema.required().min(0).max(yup.ref('quantidadeFinalMargemCartao'))
      })
      .transform((v) => (v || v === 0 ? v : null))
      .nullable(),
    quantidadeFinalMargemCartao: yup
      .number()
      .when('margemCartao', {
        is: true,
        then: (schema) =>
          schema
            .required()
            .min(yup.ref('quantidadeInicialMargemCartao'))
            .max(1000000000.0)
      })
      .transform((v) => (v || v === 0 ? v : null))
      .nullable()
  },
  [
    ['idadeInicial', 'idadeFinal'],
    ['despachoAnoInicial', 'despachoAnoFinal']
  ]
)

export const schemaTab3 = yup.object().shape({
  bancosPagadoresConsiderarCampanha: yup.array().of(yup.string().required())
})

export const schemaTab4 = yup.object().shape({
  instituicaoFinanceiraCampanha: yup.array().of(yup.string().required()),
  parcelas: yup.boolean().required(),
  quantidadeInicialParcelas: yup
    .number()
    .when('parcelas', {
      is: true,
      then: (schema) => schema.min(0).max(yup.ref('quantidadeFinalParcelas'))
    })
    .transform((v) => {
      return v || v === 0 ? v : null
    })
    .nullable(),
  quantidadeFinalParcelas: yup
    .number()
    .when('parcelas', {
      is: true,
      then: (schema) => schema.min(yup.ref('quantidadeInicialParcelas'))
    })
    .transform((v) => {
      return v || v === 0 ? v : null
    })
    .nullable(),
  valorParcela: yup.boolean().required(),
  quantidadeInicialValorParcela: yup
    .number()
    .when('valorParcela', {
      is: true,
      then: (schema) =>
        schema.required().min(0).max(yup.ref('quantidadeFinalValorParcela'))
    })
    .transform((v) => {
      return v || v === 0 ? v : null
    })
    .nullable(),
  quantidadeFinalValorParcela: yup
    .number()
    .when('valorParcela', {
      is: true,
      then: (schema) =>
        schema
          .required()
          .min(yup.ref('quantidadeInicialValorParcela'))
          .max(1000000000.0)
    })
    .transform((v) => {
      return v || v === 0 ? v : null
    })
    .nullable()
})

export const schemaTab5 = yup.object().shape({
  tiposCampanhaId: yup.string().required('Tipo de campanha é obrigatório'),
  horaInicio: yup
    .number()
    .typeError('Hora de início é obrigatória')
    .required('Hora de início é obrigatória')
    .min(0, 'Hora de início deve ser entre 0 e 23')
    .max(23, 'Hora de início deve ser entre 0 e 23'),

  horaFim: yup
    .number()
    .typeError('Hora de fim é obrigatória')
    .required('Hora de fim é obrigatória')
    .min(0, 'Hora de fim deve ser entre 0 e 23')
    .max(23, 'Hora de fim deve ser entre 0 e 23'),

  pergunta: yup
    .number()
    .typeError('Pergunta deve ser um número')
    .min(1, 'Pergunta deve ser no mínimo 1')
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .when('tiposCampanhaId', ([tipo]: any[], schema) => {
      if (tipo === 'd38a3f12-927f-4936-8eee-6552ce2ed81e') {
        return schema.required('Pergunta é obrigatória')
      }
      return schema.notRequired().nullable()
    })
})
export const schemaTab6 = yup.object().shape({
  agenteVoz: yup.string().nullable().required('Agente de voz é obrigatório'),
  numerosOrigemElevenLabsId: yup.string().nullable().required('Número de origem é obrigatório'),
  tempoLimiteToque: yup
    .number()
    .integer('Deve ser um número inteiro')
    .min(1, 'Mínimo de 1 segundo')
    .max(999, 'Máximo de 999 segundos')
    .transform((v) => (v || v === 0 ? v : null))
    .nullable(),
  limiteConcorrencia: yup
    .number()
    .integer('Deve ser um número inteiro')
    .min(1, 'Deve ser no mínimo 1')
    .transform((v) => (v || v === 0 ? v : null))
    .nullable()
})
